module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhand7-4a1fff146830034b900a821f7b2b2158.jpg";